import React from 'react';

function Staff() {
  return <div className="container mt-5"><h2>Staff Dashboard</h2></div>;
}

export default Staff;